import { render, staticRenderFns } from "./NsAddressTh.vue?vue&type=template&id=c3abbf8c&"
import script from "./NsAddressTh.vue?vue&type=script&lang=js&"
export * from "./NsAddressTh.vue?vue&type=script&lang=js&"
import style0 from "./NsAddressTh.vue?vue&type=style&index=0&lang=scss&module=%24x&"




function injectStyles (context) {
  
  this["$x"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports